import { Github, Mail, Zap } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-bolt-surface border-t border-bolt-border mt-auto">
      <div className="container-custom py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-6 h-6 bg-primary-600 rounded-md flex items-center justify-center">
                <Zap className="h-3.5 w-3.5 text-white" fill="currentColor" />
              </div>
              <span className="text-sm font-semibold text-bolt-text">StackBlitz Team</span>
            </div>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-widest text-bolt-textSubtle mb-3">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-xs text-bolt-textMuted hover:text-bolt-text transition-colors">
                  World Map
                </a>
              </li>
              <li>
                <a href="/" className="text-xs text-bolt-textMuted hover:text-bolt-text transition-colors">
                  Team Directory
                </a>
              </li>
              <li>
                <Link to="/insights" className="text-xs text-bolt-textMuted hover:text-bolt-text transition-colors">
                  Team Insights
                </Link>
              </li>
              <li>
                <Link to="/pets" className="text-xs text-bolt-textMuted hover:text-bolt-text transition-colors">
                  Meet the Pets
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-widest text-bolt-textSubtle mb-3">Contact</h3>
            <div className="space-y-2">
              <a
                href="mailto:alexk@stackblitz.com"
                className="flex items-center gap-2 text-xs text-bolt-textMuted hover:text-bolt-text transition-colors"
              >
                <Mail className="h-3.5 w-3.5 text-bolt-textSubtle" />
                alexk@stackblitz.com
              </a>
              <a
                href="https://github.com/stackblitz/stack-map"
                className="flex items-center gap-2 text-xs text-bolt-textMuted hover:text-bolt-text transition-colors"
              >
                <Github className="h-3.5 w-3.5 text-bolt-textSubtle" />
                github.com/stackblitz/stack-map
              </a>
            </div>
          </div>
        </div>

        <div className="mt-6 pt-5 border-t border-bolt-border/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-bolt-textSubtle">
            &copy; {currentYear} StackBlitz. All rights reserved.
          </p>
          <div className="flex items-center gap-3">
            <span className="text-xs text-bolt-textSubtle">Found a bug? New feature idea?</span>
            <a
              href="https://bolt.new/~/github-6jdckhpk"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-semibold bg-primary-600 hover:bg-primary-500 text-white transition-colors"
            >
              <Zap className="h-3 w-3" fill="currentColor" />
              Edit in Bolt
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
